import { createFileRoute } from '@tanstack/react-router';

import { KlevScreen } from '@/screens/KlevScreen';

export const Route = createFileRoute('/_app/klev')({
  component: KlevScreen,
});
